import React from 'react';
import SecaoFeiraShared from '@alweb-merkator/shared/pages/PaginaInicial/SecaoFeira';

function SecaoFeira(props) {
  return <SecaoFeiraShared {...props} />;
}

export default SecaoFeira;
